import { computed, reactive } from "vue";
import dashboardApi from "../api";

export default function (type, chartType = "treemap") {
  const data = reactive({
    series: [],
    options: {
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          return (opts?.value ?? 0) + " чел.";
        },
      },
      chart: {
        fontFamily: "Source Sans Pro, Arial, sans-serif",
        type: chartType,
        toolbar: {
          show: false,
        },
      },
      colors: [
        "#5B9BD5",
        "#4472C4",
        "#FFC000",
        "#A5A5A5",
        "#ED7D31",
        "#0d233a",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a",
      ],

      legend: {
        show: true,
        showForSingleSeries: true,
        position: "right",
        horizontalAlign: "center",
        width: 250,
        offsetX: 0,
        itemMargin: {
          horizontal: 0,
        },
        markers: {
          offsetX: -5,
        },
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: (value) => value + " чел.",
          title: {
            // formatter: function () {
            //   return "Тест";
            // },
          },
        },
      },
    },
  });
  const loadReport = async () => {
    const res = await dashboardApi.getPMPKReport({ type });
    // const sum = res.data.reduce((acc, { count }) => acc + count, 0);
    Object.assign(data, {
      ...data,
      series: res.data.map(({ text: name, count: y }) => {
        name = name
          .replace(
            "Дополнительная общеобразовательная предпрофессиональная программа",
            "ДОПП"
          )
          .replace(
            "Образовательная программа дополнительного профессионального образования",
            "ОПДПО"
          )
          .replace(
            "Дополнительная общеобразовательная общеразвивающая программа",
            "ДООП"
          )
          .replace("общеобразовательная программа", "ОП");

        return { name: name ?? "Не указано", data: [{ x: name, y }] };
      }),
      options: {
        ...data.options,
      },
    });
  };
  loadReport();
  return {
    data: computed(() => data),
    loadReport,
  };
}
